<style>
.divider-col {
  margin-top: 0 !important;
}
hr.style1 {
  border-top: 1px solid #8c8b8b;
}
.hr-sect {
  display: flex;
  flex-basis: 100%;
  align-items: center;
  color: rgba(0, 0, 0, 1);
  margin: 10px 0px;
  font-size: 15px;
}
.hr-sect:before,
.hr-sect:after {
  content: "";
  flex-grow: 1;
  background: rgba(0, 0, 0, 0.35);
  height: 1px;
  font-size: 0px;
  line-height: 0px;
  margin: 0px 0px;
}
</style>
<template>
  <div>
    <div>
      <b-form>
        <legend><strong>Dokumen</strong></legend>
        <b-row>
          <template>
            <b-col md="5">
              <p style="font-weight: 900; font-size: 17px">
                Surat Permohonan Perizinan Non Berusaha
              </p>
            </b-col>
            <b-col md="3"> </b-col>
            <b-col md="4">
              <b-form-group>
                <!-- <b-button variant="success" v-if="dataPermohonan.file_persyaratan_lain" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                <b-button
                  variant="success"
                  v-if="
                    dataPermohonan.filename_surat_permohonan_perizinan_nonberusaha ==
                    null
                  "
                  disabled
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Tidak ada data"
                  class="text-white"
                  style="margin-right: 5px"
                  ><i class="fa fa-download" /> Download</b-button
                >
                <a
                  :href="
                    dataPermohonan.filename_surat_permohonan_perizinan_nonberusaha
                  "
                  v-else
                  type="button"
                  class="btn btn-success"
                  target="_blank"
                  rel="noopener noreferrer"
                  ><i class="fa fa-download" /> Download</a
                >
                <!-- <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault">
                                    <label class="form-check-label" for="flexSwitchCheckDefault">Sesuai</label>
                                </div> -->
              </b-form-group>
            </b-col>
            <b-col md="12" class="divider-col">
              <hr class="style1" md="12" />
            </b-col>
          </template>
          <b-col md="5">
            <p style="font-weight: 900; font-size: 17px">Koordinat</p>
          </b-col>
          <b-col md="3"> </b-col>
          <b-col md="4">
            <b-form-group>
              <b-button
                variant="success"
                v-if="dataPermohonan.file_kordinat == null"
                disabled
                data-toggle="tooltip"
                data-placement="top"
                title="Tidak ada data"
                class="text-white"
                style="margin-right: 5px"
                ><i class="fa fa-download" /> Download</b-button
              >
              <a
                :href="dataPermohonan.file_kordinat"
                v-else
                type="button"
                class="btn btn-success"
                target="_blank"
                rel="noopener noreferrer"
                ><i class="fa fa-download" /> Download</a
              >
            </b-form-group>
          </b-col>
          <div class="divider div-transparent"></div>
          <b-col md="5">
            <p style="font-weight: 900; font-size: 17px">
              Rencana Bangunan dan Instalasi di Laut
            </p>
          </b-col>
          <b-col md="3"> </b-col>
          <b-col md="4">
            <!-- <b-button variant="success" v-if="dataPermohonan.file_rencana_bangunan_dan_instalasi_di_laut != null" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
            <b-button
              variant="success"
              v-if="
                dataPermohonan.file_rencana_bangunan_dan_instalasi_di_laut ==
                null
              "
              disabled
              data-toggle="tooltip"
              data-placement="top"
              title="Tidak ada data"
              class="text-white"
              style="margin-right: 5px"
              ><i class="fa fa-download" /> Download</b-button
            >
            <a
              :href="dataPermohonan.file_rencana_bangunan_dan_instalasi_di_laut"
              v-else
              type="button"
              class="btn btn-success"
              target="_blank"
              rel="noopener noreferrer"
              ><i class="fa fa-download" /> Download</a
            >
          </b-col>
          <!-- <b-col md="12" class="divider-col">
                            <hr class="style1 hr-blurry" md="12">
                        </b-col> -->
          <b-col md="12">
            <div class="hr-sect">Rencana Kegiatan</div>
          </b-col>
          <!-- <b-col md="3">
                        
                        </b-col>
                        <b-col md="4">
                        
                        </b-col> -->
          <!-- <b-col md="12" class="divider-col">
                            <hr class="style1" md="12">
                        </b-col> -->

          <b-col md="8">
            <div>
              Dokumen dasar berupa kegiatan, tujuan dan manfaat kegiatan usaha
            </div>
          </b-col>
          <!-- <b-col md="3">
                            <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group>
                        </b-col> -->
          <b-col md="4">
            <!-- <b-form-group> -->
            <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
            <div class="form-check form-switch">
              <input
                disabled
                v-model="dataPermohonan.verifikasi_dokumen_dasar"
                @change="simpanIndikator('verifikasi_dokumen_dasar')"
                class="form-check-input"
                type="checkbox"
                id="flexSwitchCheckDefault"
              />
              <label class="form-check-label" for="flexSwitchCheckDefault">{{
                dataPermohonan.verifikasi_dokumen_dasar
                  ? "Sesuai"
                  : "TIdak Sesuai"
              }}</label>
            </div>
            <!-- </b-form-group> -->
          </b-col>
          <b-col md="12" class="divider-col">
            <hr class="style1" md="12" />
          </b-col>

          <b-col md="5">
            <div>Kegiatan eksisting yang dimohonkan</div>
          </b-col>
          <b-col md="3">
            <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
          </b-col>
          <b-col md="4">
            <!-- <b-form-group> -->
            <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
            <div class="form-check form-switch">
              <input
                disabled
                v-model="dataPermohonan.verifikasi_kegiatan_eksisting"
                @change="simpanIndikator('verifikasi_kegiatan_eksisting')"
                class="form-check-input"
                type="checkbox"
                id="flexSwitchCheckDefault2"
              />
              <label class="form-check-label" for="flexSwitchCheckDefault2">{{
                dataPermohonan.verifikasi_kegiatan_eksisting
                  ? "Sesuai"
                  : "Tidak Sesuai"
              }}</label>
            </div>
            <!-- </b-form-group> -->
          </b-col>
          <b-col md="12" class="divider-col">
            <hr class="style1" md="12" />
          </b-col>
          <b-col md="8">
            <div>
              Rencana jadwal pelaksanaan kegiatan utama dan pendukungnya
            </div>
          </b-col>
          <!-- <b-col md="3">
                            <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group>
                        </b-col> -->
          <b-col md="4">
            <!-- <b-form-group> -->
            <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
            <div class="form-check form-switch">
              <input
                disabled
                v-model="dataPermohonan.verifikasi_rencana_jadwal"
                @change="simpanIndikator('verifikasi_rencana_jadwal')"
                class="form-check-input"
                type="checkbox"
                id="flexSwitchCheckDefault3"
              />
              <label class="form-check-label" for="flexSwitchCheckDefault3">{{
                dataPermohonan.verifikasi_rencana_jadwal
                  ? "Sesuai"
                  : "Tidak Sesuai"
              }}</label>
            </div>
            <!-- </b-form-group> -->
          </b-col>
          <b-col md="12" class="divider-col">
            <hr class="style1" md="12" />
          </b-col>
          <b-col md="8">
            <div>
              Rencana tapak/site plan kegiatan yang dilengkapi dengan rencana
              bangunan dan instalasi di laut serta fasilitas penunjangnya
            </div>
          </b-col>
          <!-- <b-col md="3"> -->
          <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
          <!-- </b-col> -->
          <b-col md="4">
            <!-- <b-form-group> -->
            <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
            <div class="form-check form-switch">
              <input
                disabled
                v-model="dataPermohonan.verifikasi_rencana_site_plan"
                @change="simpanIndikator('verifikasi_rencana_site_plan')"
                class="form-check-input"
                type="checkbox"
                id="flexSwitchCheckDefault4"
              />
              <label class="form-check-label" for="flexSwitchCheckDefault4">{{
                dataPermohonan.verifikasi_rencana_site_plan
                  ? "Sesuai"
                  : "Tidak Sesuai"
              }}</label>
            </div>
            <!-- </b-form-group> -->
          </b-col>
          <b-col md="12" class="divider-col">
            <hr class="style1" md="12" />
          </b-col>
          <b-col md="8">
            <div>
              Deksriptif luasan (Ha) yang dibutuhkan pada lokasi usaha yang
              dimohonkan per kegiatan utama dan penunjangnya
            </div>
          </b-col>
          <!-- <b-col md="3">
                            <b-form-group> -->
          <!-- <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file> -->
          <!-- </b-form-group>
                        </b-col> -->
          <b-col md="4">
            <!-- <b-form-group> -->
            <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
            <div class="form-check form-switch">
              <input
                disabled
                v-model="dataPermohonan.verifikasi_deskriptif_luasan"
                @change="simpanIndikator('verifikasi_deskriptif_luasan')"
                class="form-check-input"
                type="checkbox"
                id="flexSwitchCheckDefault5"
              />
              <label class="form-check-label" for="flexSwitchCheckDefault5">{{
                dataPermohonan.verifikasi_deskriptif_luasan
                  ? "Sesuai"
                  : "Tidak Sesuai"
              }}</label>
            </div>
            <!-- </b-form-group> -->
          </b-col>
          <b-col md="12" class="divider-col">
            <hr class="style1" md="12" />
          </b-col>
          <b-col md="8">
            <div>
              Peta lokasi/plotting batas-batas area dan/atau jalur disertai
              titik koordinat lokasi dengan sistem koordinat lintang (latitude)
              dan bujur (longitude) berskala minimal 1:50.000.
            </div>
          </b-col>

          <b-col md="4">
            <!-- <b-form-group> -->
            <div class="form-check form-switch">
              <input
                disabled
                v-model="dataPermohonan.verifikasi_peta_lokasi"
                @change="simpanIndikator('verifikasi_peta_lokasi')"
                class="form-check-input"
                type="checkbox"
                id="flexSwitchCheckDefault6"
              />
              <label class="form-check-label" for="flexSwitchCheckDefault6">{{
                dataPermohonan.verifikasi_peta_lokasi
                  ? "Sesuai"
                  : "Tidak Sesuai"
              }}</label>
            </div>
            <!-- </b-form-group> -->
          </b-col>
          <b-col md="12" class="divider-col">
            <hr class="style1" md="12" />
          </b-col>
          <b-col md="5">
            <div>
              <p style="font-weight: 900; font-size: 17px">
                Informasi Pemanfaatan Ruang Laut
              </p>
            </div>
          </b-col>
          <b-col md="3"> </b-col>
          <b-col md="4">
            <b-form-group>
              <!-- <b-button variant="success" v-if="dataPermohonan.file_informasi_prl != null" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
              <b-button
                variant="success"
                v-if="dataPermohonan.file_informasi_prl == null"
                disabled
                data-toggle="tooltip"
                data-placement="top"
                title="Tidak ada data"
                class="text-white"
                style="margin-right: 5px"
                ><i class="fa fa-download" /> Download</b-button
              >
              <a
                :href="dataPermohonan.file_informasi_prl"
                v-else
                type="button"
                class="btn btn-success"
                target="_blank"
                rel="noopener noreferrer"
                ><i class="fa fa-download" /> Download</a
              >
              <!-- <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault">
                                    <label class="form-check-label" for="flexSwitchCheckDefault">Sesuai</label>
                                </div> -->
            </b-form-group>
          </b-col>

          <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="8">
                  <div>
                    Informasi Pemanfaatan Ruang Laut di sekitar Area Permohonan
                  </div>
                </b-col>

                <b-col md="4">
                  <!-- <b-form-group> -->
                  <div class="form-check form-switch">
                    <input
                    disabled
                      v-model="dataPermohonan.verifikasi_informasi_prl"
                      @change="simpanIndikator('verifikasi_informasi_prl')"
                      class="form-check-input"
                      type="checkbox"
                      id="flexSwitchCheckDefault20"
                    />
                    <label
                      class="form-check-label"
                      for="flexSwitchCheckDefault20"
                      >{{
                        dataPermohonan.verifikasi_informasi_prl
                          ? "Sesuai"
                          : "Tidak Sesuai"
                      }}</label
                    >
                  </div>
                  <!-- </b-form-group> -->
                </b-col>

                <b-col md="12" class="divider-col">
                            <hr class="style1" md="12">
                        </b-col>
          <!-- <b-col md="12" class="divider-col">
                            <hr class="style1" md="12">
                        </b-col> -->
          <b-col md="5">
            <div>
              <p style="font-weight: 900; font-size: 17px">
                Data kondisi terkini lokasi dan sekitarnya (ekosistem,
                hidrografi, dan oseanografi)
              </p>
            </div>
          </b-col>
          <b-col md="3"> </b-col>
          <b-col md="4">
            <!-- <b-button variant="success" v-if="dataPermohonan.file_data_kondisi_terkini != null" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
            <b-button
              variant="success"
              v-if="dataPermohonan.file_data_kondisi_terkini == null"
              disabled
              data-toggle="tooltip"
              data-placement="top"
              title="Tidak ada data"
              class="text-white"
              style="margin-right: 5px"
              ><i class="fa fa-download" /> Download</b-button
            >
            <a
              :href="dataPermohonan.file_data_kondisi_terkini"
              v-else
              type="button"
              class="btn btn-success"
              target="_blank"
              rel="noopener noreferrer"
              ><i class="fa fa-download" /> Download</a
            >
          </b-col>
          <!-- <b-col md="12" class="divider-col">
                            <hr class="style1" md="12">
                        </b-col> -->
          <b-col md="12">
            <div class="hr-sect">Ekosistem Sekitar</div>
          </b-col>
          <!-- <b-col md="3">
                        </b-col>
                        <b-col md="4">
                        </b-col> -->
          <!-- <b-col md="12" class="divider-col">
                            <hr class="style1" md="12">
                        </b-col> -->
          <b-col md="5">
            <div>Mangrove</div>
          </b-col>
          <b-col md="3">
            <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
          </b-col>
          <b-col md="4">
            <!-- <b-form-group> -->
            <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
            <div class="form-check form-switch">
              <input
                disabled
                v-model="dataPermohonan.verifikasi_magrove"
                @change="simpanIndikator('verifikasi_magrove')"
                class="form-check-input"
                type="checkbox"
                id="flexSwitchCheckDefault7"
              />
              <label class="form-check-label" for="flexSwitchCheckDefault7">{{
                dataPermohonan.verifikasi_magrove ? "Sesuai" : "Tidak Sesuai"
              }}</label>
            </div>
            <!-- </b-form-group> -->
          </b-col>
          <b-col md="12" class="divider-col">
            <hr class="style1" md="12" />
          </b-col>
          <b-col md="5">
            <div>Lamun</div>
          </b-col>
          <b-col md="3">
            <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
          </b-col>
          <b-col md="4">
            <!-- <b-form-group> -->
            <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
            <div class="form-check form-switch">
              <input
                disabled
                class="form-check-input"
                @change="simpanIndikator('verifikasi_lamun')"
                v-model="dataPermohonan.verifikasi_lamun"
                type="checkbox"
                id="flexSwitchCheckDefault8"
              />
              <label class="form-check-label" for="flexSwitchCheckDefault8">{{
                dataPermohonan.verifikasi_lamun ? "Sesuai" : "Tidak Sesuai"
              }}</label>
            </div>
            <!-- </b-form-group> -->
          </b-col>
          <b-col md="12" class="divider-col">
            <hr class="style1" md="12" />
          </b-col>
          <b-col md="8">
            <div>Terumbu karang</div>
          </b-col>

          <b-col md="4">
            <!-- <b-form-group> 
                                <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
            <div class="form-check form-switch">
              <input
                disabled
                class="form-check-input"
                @change="simpanIndikator('verifikasi_terumbu_karang')"
                v-model="dataPermohonan.verifikasi_terumbu_karang"
                type="checkbox"
                id="flexSwitchCheckDefault9"
              />
              <label class="form-check-label" for="flexSwitchCheckDefault9">{{
                dataPermohonan.verifikasi_terumbu_karang
                  ? "Sesuai"
                  : "Tidak Sesuai"
              }}</label>
            </div>
          </b-col>

          <!-- <b-col md="12" class="divider-col">
                            <hr class="style1" md="12">
                        </b-col> -->
          <b-col md="12">
            <div class="hr-sect">Hidro-oseanografi</div>
          </b-col>
          <!-- <b-col md="3">
                        
                        </b-col>
                        <b-col md="4">
                        
                        </b-col>
                        <b-col md="12" class="divider-col">
                            <hr class="style1" md="12">
                        </b-col> -->
          <b-col md="5">
            <div>Arus</div>
          </b-col>
          <b-col md="3">
            <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
          </b-col>
          <b-col md="4">
            <!-- <b-form-group> -->
            <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
            <div class="form-check form-switch">
              <input
                disabled
                class="form-check-input"
                @change="simpanIndikator('verifikasi_arus')"
                v-model="dataPermohonan.verifikasi_arus"
                type="checkbox"
                id="flexSwitchCheckDefault10"
              />
              <label class="form-check-label" for="flexSwitchCheckDefault10">{{
                dataPermohonan.verifikasi_arus ? "Sesuai" : "Tidak Sesuai"
              }}</label>
            </div>
            <!-- </b-form-group> -->
          </b-col>
          <b-col md="12" class="divider-col">
            <hr class="style1" md="12" />
          </b-col>
          <b-col md="5">
            <div>Gelombang</div>
          </b-col>
          <b-col md="3">
            <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
          </b-col>
          <b-col md="4">
            <!-- <b-form-group> -->
            <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
            <div class="form-check form-switch">
              <input
                disabled
                class="form-check-input"
                @change="simpanIndikator('verifikasi_gelombang')"
                v-model="dataPermohonan.verifikasi_gelombang"
                type="checkbox"
                id="flexSwitchCheckDefault11"
              />
              <label class="form-check-label" for="flexSwitchCheckDefault11">{{
                dataPermohonan.verifikasi_gelombang ? "Sesuai" : "Tidak Sesuai"
              }}</label>
            </div>
            <!-- </b-form-group> -->
          </b-col>
          <b-col md="12" class="divider-col">
            <hr class="style1" md="12" />
          </b-col>
          <b-col md="5">
            <div>Pasang Surut</div>
          </b-col>
          <b-col md="3">
            <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
          </b-col>
          <b-col md="4">
            <!-- <b-form-group> -->
            <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
            <div class="form-check form-switch">
              <input
                disabled
                class="form-check-input"
                @change="simpanIndikator('verifikasi_pasang_surut')"
                v-model="dataPermohonan.verifikasi_pasang_surut"
                type="checkbox"
                id="flexSwitchCheckDefault12"
              />
              <label class="form-check-label" for="flexSwitchCheckDefault12">{{
                dataPermohonan.verifikasi_pasang_surut
                  ? "Sesuai"
                  : "Tidak Sesuai"
              }}</label>
            </div>
            <!-- </b-form-group> -->
          </b-col>
          <b-col md="12" class="divider-col">
            <hr class="style1" md="12" />
          </b-col>
          <b-col md="5">
            <div>Bathimetri</div>
          </b-col>
          <b-col md="3">
            <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
          </b-col>
          <b-col md="4">
            <!-- <b-form-group> -->
            <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
            <div class="form-check form-switch">
              <input
                disabled
                class="form-check-input"
                @change="simpanIndikator('verifikasi_bathimetri')"
                v-model="dataPermohonan.verifikasi_bathimetri"
                type="checkbox"
                id="flexSwitchCheckDefault13"
              />
              <label class="form-check-label" for="flexSwitchCheckDefault13">{{
                dataPermohonan.verifikasi_bathimetri ? "Sesuai" : "Tidak Sesuai"
              }}</label>
            </div>
            <!-- </b-form-group> -->
          </b-col>
          <b-col md="12" class="divider-col">
            <hr class="style1" md="12" />
          </b-col>
          <b-col md="5">
            <p style="font-size: 15px">Profil dasar laut disertai gambar</p>
          </b-col>
          <b-col md="3">
            <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
          </b-col>
          <b-col md="4">
            <!-- <b-form-group> -->
            <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
            <div class="form-check form-switch">
              <input
                disabled
                class="form-check-input"
                @change="simpanIndikator('verifikasi_profil_dasar_laut')"
                v-model="dataPermohonan.verifikasi_profil_dasar_laut"
                type="checkbox"
                id="flexSwitchCheckDefault14"
              />
              <label class="form-check-label" for="flexSwitchCheckDefault14">{{
                dataPermohonan.verifikasi_profil_dasar_laut
                  ? "Sesuai"
                  : "Tidak Sesuai"
              }}</label>
            </div>
            <!-- </b-form-group> -->
          </b-col>
          <b-col md="12" class="divider-col">
            <hr class="style1" md="12" />
          </b-col>
          <b-col md="5">
            <p style="font-size: 15px">
              Kondisi/karakteristik sosial ekonomi masyarakat
            </p>
          </b-col>
          <b-col md="3">
            <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
          </b-col>
          <b-col md="4">
            <!-- <b-form-group> -->
            <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
            <div class="form-check form-switch">
              <input
                disabled
                class="form-check-input"
                @change="simpanIndikator('verifikasi_kondisi_sosial_ekonomi')"
                v-model="dataPermohonan.verifikasi_kondisi_sosial_ekonomi"
                type="checkbox"
                id="flexSwitchCheckDefault15"
              />
              <label class="form-check-label" for="flexSwitchCheckDefault15">{{
                dataPermohonan.verifikasi_kondisi_sosial_ekonomi
                  ? "Sesuai"
                  : "Tidak Sesuai"
              }}</label>
            </div>
            <!-- </b-form-group> -->
          </b-col>
          <b-col md="12" class="divider-col">
            <hr class="style1" md="12" />
          </b-col>
          <b-col md="5">
            <p style="font-size: 15px">Aksesibilitas lokasi dan sekitar</p>
          </b-col>
          <b-col md="3">
            <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
          </b-col>
          <b-col md="4">
            <!-- <b-form-group> -->
            <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
            <div class="form-check form-switch">
              <input
                disabled
                class="form-check-input"
                @change="simpanIndikator('verifikasi_aksesibilitas_lokasi')"
                v-model="dataPermohonan.verifikasi_aksesibilitas_lokasi"
                type="checkbox"
                id="flexSwitchCheckDefault16"
              />
              <label class="form-check-label" for="flexSwitchCheckDefault16">{{
                dataPermohonan.verifikasi_aksesibilitas_lokasi
                  ? "Sesuai"
                  : "Tidak Sesuai"
              }}</label>
            </div>
            <!-- </b-form-group> -->
          </b-col>
          <b-col md="12" class="divider-col">
            <hr class="style1" md="12" />
          </b-col>
          <b-col md="5">
            <p style="font-weight: 900; font-size: 17px">Persyaratan Lainnya</p>
          </b-col>
          <b-col md="3"> </b-col>
          <b-col md="4">
            <b-form-group>
              <!-- <b-button variant="success" v-if="dataPermohonan.file_persyaratan_lain" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
              <b-button
                variant="success"
                v-if="dataPermohonan.file_persyaratan_lain == null"
                disabled
                data-toggle="tooltip"
                data-placement="top"
                title="Tidak ada data"
                class="text-white"
                style="margin-right: 5px"
                ><i class="fa fa-download" /> Download</b-button
              >
              <a
                :href="dataPermohonan.file_persyaratan_lain"
                v-else
                type="button"
                class="btn btn-success"
                target="_blank"
                rel="noopener noreferrer"
                ><i class="fa fa-download" /> Download</a
              >
              <!-- <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault">
                                    <label class="form-check-label" for="flexSwitchCheckDefault">Sesuai</label>
                                </div> -->
            </b-form-group>
          </b-col>

          <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="8">
                  <div>
                    Surat Permohonan Pengenaan Tarif Rp 0,00 (Nol Rupiah)
                  </div>
                </b-col>

                <b-col md="4">
                  <!-- <b-form-group> -->
                  <div class="form-check form-switch">
                    <input
                    disabled
                      v-model="dataPermohonan.verifikasi_surat_permohonan_pengenaan_tarif_nol"
                      @change="simpanIndikator('verifikasi_surat_permohonan_pengenaan_tarif_nol')"
                      class="form-check-input"
                      type="checkbox"
                      id="flexSwitchCheckDefault21"
                    />
                    <label
                      class="form-check-label"
                      for="flexSwitchCheckDefault21"
                      >{{
                        dataPermohonan.verifikasi_surat_permohonan_pengenaan_tarif_nol
                          ? "Sesuai"
                          : "Tidak Sesuai"
                      }}</label
                    >
                  </div>
                  <!-- </b-form-group> -->
                </b-col>

                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="8">
                  <div>
                    Bukti Penggunaan APBN/APBD untuk Pemohon dari Instansi Pusat/Daerah
                  </div>
                </b-col>

                <b-col md="4">
                  <!-- <b-form-group> -->
                  <div class="form-check form-switch">
                    <input
                    disabled
                      v-model="dataPermohonan.verifikasi_bukti_penggunaan_apbd_apbn"
                      @change="simpanIndikator('verifikasi_bukti_penggunaan_apbd_apbn')"
                      class="form-check-input"
                      type="checkbox"
                      id="flexSwitchCheckDefault22"
                    />
                    <label
                      class="form-check-label"
                      for="flexSwitchCheckDefault22"
                      >{{
                        dataPermohonan.verifikasi_bukti_penggunaan_apbd_apbn
                          ? "Sesuai"
                          : "Tidak Sesuai"
                      }}</label
                    >
                  </div>
                  <!-- </b-form-group> -->
                </b-col>

          <template v-if="dataPermohonan.reklamasi == true">
            <b-col md="12" class="divider-col">
              <hr class="style1" md="12" />
            </b-col>
            <b-col md="5">
              <p style="font-weight: 900; font-size: 17px">
                Persyaratan Reklamasi
              </p>
            </b-col>
            <b-col md="3"> </b-col>
            <b-col md="4">
              <b-form-group>
                <!-- <b-button variant="success" v-if="dataPermohonan.file_persyaratan_reklamasi != null" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                <b-button
                  variant="success"
                  v-if="dataPermohonan.file_persyaratan_reklamasi == null"
                  disabled
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Tidak ada data"
                  class="text-white"
                  style="margin-right: 5px"
                  ><i class="fa fa-download" /> Download</b-button
                >
                <a
                  :href="dataPermohonan.file_persyaratan_reklamasi"
                  v-else
                  type="button"
                  class="btn btn-success"
                  target="_blank"
                  rel="noopener noreferrer"
                  ><i class="fa fa-download" /> Download</a
                >
                <!-- <div class="form-check form-switch">
                                        <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault">
                                        <label class="form-check-label" for="flexSwitchCheckDefault">Sesuai</label>
                                    </div> -->
              </b-form-group>
            </b-col>
            <b-col md="12" class="divider-col">
              <hr class="style1" md="12" />
            </b-col>
            <b-col md="5">
              <div>Rencana pengambilan sumber material reklamasi</div>
            </b-col>
            <b-col md="3">
              <!-- <b-form-group>
                                    <b-form-file
                                    placeholder="Choose a file or drop it here..."
                                    drop-placeholder="Drop file here..."
                                    plain
                                    class="form-control"
                                    ></b-form-file>
                                </b-form-group> -->
            </b-col>
            <b-col md="4">
              <!-- <b-form-group> -->
              <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                    <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
              <div class="form-check form-switch">
                <input
                  disabled
                  class="form-check-input"
                  @change="
                    simpanIndikator(
                      'verifikasi_rencana_pengambilan_sumber_material'
                    )
                  "
                  v-model="
                    dataPermohonan.verifikasi_rencana_pengambilan_sumber_material
                  "
                  type="checkbox"
                  id="flexSwitchCheckDefault17"
                />
                <label
                  class="form-check-label"
                  for="flexSwitchCheckDefault17"
                  >{{
                    dataPermohonan.verifikasi_rencana_pengambilan_sumber_material
                      ? "Sesuai"
                      : "Tidak Sesuai"
                  }}</label
                >
              </div>
              <!-- </b-form-group> -->
            </b-col>
            <b-col md="12" class="divider-col">
              <hr class="style1" md="12" />
            </b-col>
            <b-col md="5">
              <div>Rencana pemanfaatan lahan reklamasi</div>
            </b-col>
            <b-col md="3">
              <!-- <b-form-group>
                                    <b-form-file
                                    placeholder="Choose a file or drop it here..."
                                    drop-placeholder="Drop file here..."
                                    plain
                                    class="form-control"
                                    ></b-form-file>
                                </b-form-group> -->
            </b-col>
            <b-col md="4">
              <!-- <b-form-group> -->
              <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                    <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
              <div class="form-check form-switch">
                <input
                  disabled
                  class="form-check-input"
                  @change="
                    simpanIndikator(
                      'verifikasi_rencana_pemanfaatan_lahan_reklamasi'
                    )
                  "
                  v-model="
                    dataPermohonan.verifikasi_rencana_pemanfaatan_lahan_reklamasi
                  "
                  type="checkbox"
                  id="flexSwitchCheckDefault18"
                />
                <label
                  class="form-check-label"
                  for="flexSwitchCheckDefault18"
                  >{{
                    dataPermohonan.verifikasi_rencana_pemanfaatan_lahan_reklamasi
                      ? "Sesuai"
                      : "Tidak Sesuai"
                  }}</label
                >
              </div>
              <!-- </b-form-group> -->
            </b-col>
            <b-col md="12" class="divider-col">
              <hr class="style1" md="12" />
            </b-col>
            <b-col md="5">
              <div>Gambaran umum pelaksanaan reklamasi</div>
            </b-col>
            <b-col md="3">
              <!-- <b-form-group>
                                    <b-form-file
                                    placeholder="Choose a file or drop it here..."
                                    drop-placeholder="Drop file here..."
                                    plain
                                    class="form-control"
                                    ></b-form-file>
                                </b-form-group> -->
            </b-col>
            <b-col md="4">
              <!-- <b-form-group> -->
              <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                    <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
              <div class="form-check form-switch">
                <input
                  disabled
                  class="form-check-input"
                  @change="
                    simpanIndikator('verifikasi_gambaran_umum_reklamasi')
                  "
                  v-model="dataPermohonan.verifikasi_gambaran_umum_reklamasi"
                  type="checkbox"
                  id="flexSwitchCheckDefault19"
                />
                <label
                  class="form-check-label"
                  for="flexSwitchCheckDefault19"
                  >{{
                    dataPermohonan.verifikasi_gambaran_umum_reklamasi
                      ? "Sesuai"
                      : "Tidak Sesuai"
                  }}</label
                >
              </div>
              <!-- </b-form-group> -->
            </b-col>
            <b-col md="12" class="divider-col">
              <hr class="style1" md="12" />
            </b-col>
            <b-col md="5">
              <div>Jadwal rencana pelaksanaan reklamasi</div>
            </b-col>
            <b-col md="3">
              <!-- <b-form-group>
                                    <b-form-file
                                    placeholder="Choose a file or drop it here..."
                                    drop-placeholder="Drop file here..."
                                    plain
                                    class="form-control"
                                    ></b-form-file>
                                </b-form-group> -->
            </b-col>
            <b-col md="4">
              <!-- <b-form-group> -->
              <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                    <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
              <div class="form-check form-switch">
                <input
                  disabled
                  class="form-check-input"
                  @change="
                    simpanIndikator('verifikasi_jadwal_rencana_reklamasi')
                  "
                  v-model="dataPermohonan.verifikasi_jadwal_rencana_reklamasi"
                  type="checkbox"
                  id="flexSwitchCheckDefault20"
                />
                <label
                  class="form-check-label"
                  for="flexSwitchCheckDefault20"
                  >{{
                    dataPermohonan.verifikasi_jadwal_rencana_reklamasi
                      ? "Sesuai"
                      : "Tidak Sesuai"
                  }}</label
                >
              </div>
              <!-- </b-form-group> -->
            </b-col>
            
          </template>
        </b-row>
        <b-col md="12" class="divider-col">
              <hr class="style1" md="12" />
            </b-col>
        <b-row>
          <b-col md="6" class="mt-3">
            <p style="font-weight: 900; font-size: 17px">Link Bahan Rapat</p>
            <b-form-group label="">
              <div class="input-group">
                <input type="text" class="form-control" v-model="dataPermohonan.url_bahan_rapat" readonly />
                <button class="btn btn-outline-primary" type="button" @click="copyText">Salin</button>
              </div>
              <small v-if="copied" class="text-success mt-1 d-block">Link berhasil disalin</small>
            </b-form-group>
          </b-col>
        </b-row>
        <b-col md="12" class="divider-col">
              <hr class="style1" md="12" />
            </b-col>
            
        <b-row class="mt-3">
          <p style="font-weight: 900; font-size: 17px">Admin Penjadwalan Pentek (Pusat/UPT)</p>
          <b-col md="6">
            <b-form-group label=""  style="color:black">
              <v-select
                id="default-select"
                :options="dataUser"
                :reduce="(user) => user.id"
                label="nama"
                v-model="dataPermohonan.id_admin"
                v-validate="'required'"
                name="Jenis Proyek"
                :class="{ 'is-invalid': errors.has('form-1.Jenis Proyek') }"
                disabled
              />
              <span
                class="text-danger"
                v-if="errors.has('form-1.Jenis Proyek')"
              >
                {{ errors.first("form-1.Jenis Proyek") }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>
        <div
          class="row">
          <b-col md="12">
            <div class="form-group mt-4">
              <b-card bg-variant="dark" text-variant="white">
                <b-card-title class="text-white">Catatan</b-card-title>
                <b-card-text>
                    <div v-if="dataPermohonan.catatan_verdok == null || dataPermohonan.catatan_verdok === ''">Tidak ada Catatan</div>
                    <div v-else v-html="dataPermohonan.catatan_verdok"></div>
                </b-card-text>
              </b-card>
              <!-- <b-form-group label="Catatan: *">
                <ckeditor
                  disabled
                  v-model="dataPermohonan.catatan_verdok"
                  :editor="wygEditor"
                ></ckeditor>
              </b-form-group> -->
            </div>
          </b-col>
        </div>
      </b-form>
      <div class="row justify-content-between">
        <div class="col-4">
          <div class="text-left">
            <b-button @click="previousDokumen()" variant="primary"
              ><i class="fa fa-caret-left" /> Sebelumnya</b-button
            >
          </div>
        </div>
        <div class="col-4">
          <div class="text-right">
            <b-button
              @click="nextDokumen()"
              style="float: right"
              variant="primary"
              >Selanjutnya <i class="fa fa-caret-right"
            /></b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
export default {
  data() {
    return {
      wygEditor: ClassicEditor,
      copied: false
    };
  },
  components: { vSelect,ClassicEditor },
  props: {
    dataPermohonan: {
      type: Array,
      default: () => {
        return [];
      },
    },

    dataUser: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  methods: {
    nextDokumen() {
      this.$emit("nextDokumen");
    },
    previousDokumen() {
      this.$emit("previousDokumen");
    },
    copyText(){
      navigator.clipboard.writeText(this.dataPermohonan.url_bahan_rapat)
      this.copied = true
      setTimeout(() => (this.copied = false), 1500)
    }
  },
};
</script>